
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporratecabdserviceinpalghar() {



    const cardData =
    {
        keyword: 'Corporate Cab Service in Palghar MIDC  ',
        heading: 'etravo : Corporate Cab Service in Palghar MIDC  ',



"headingDescription": "eTravo provides reliable Corporate Cab Services in Palghar MIDC, designed for manufacturing units, industrial companies, and corporate teams requiring safe, punctual, and efficient employee transportation. With GPS-enabled vehicles, trained chauffeurs, and 24/7 availability, eTravo ensures smooth daily commuting, shift-based transport, and executive travel across Palghar’s major industrial zones including Tarapur MIDC and Boisar. Flexible monthly plans make it a dependable mobility partner for industrial operations.",

"top": "Top Corporate Cab Service Areas in Palghar MIDC with eTravo",

"topPlaces": [
  {
    "title": "Tarapur MIDC (Boisar)",
    "description": "One of Maharashtra’s largest industrial hubs with chemical, pharmaceutical, and engineering industries operating 24/7, creating high demand for employee transport and corporate cab services. :contentReference[oaicite:1]{index=1}"
  },
  {
    "title": "Boisar Industrial Area",
    "description": "A major manufacturing and logistics zone with continuous workforce movement, requiring reliable daily pickup and drop services for employees."
  },
  {
    "title": "Palghar Industrial Zone",
    "description": "A developing industrial belt with factories and SMEs requiring structured corporate transportation and shift-based cab services."
  },
  {
    "title": "Saphale Industrial Area",
    "description": "An emerging industrial region near Palghar with growing business activity and demand for workforce mobility solutions."
  },
  {
    "title": "Vasai-Virar Industrial Belt",
    "description": "A nearby industrial corridor with multiple factories and warehouses requiring daily employee commuting support."
  },
  {
    "title": "Wada Industrial Area",
    "description": "A fast-developing MIDC zone with manufacturing units and logistics hubs needing dependable cab services for staff transport."
  },
  {
    "title": "Tarapur Atomic Power Station Zone",
    "description": "A high-security and critical industrial zone with strict transport requirements for employees and corporate staff."
  },
  {
    "title": "Boisar–Palghar Highway Corridor",
    "description": "A key commuting route connecting industrial zones, heavily used for daily employee transportation and logistics movement."
  },
  {
    "title": "Industrial Residential Clusters (Boisar & Palghar)",
    "description": "Residential zones housing industrial workforce where daily pickup and drop services are essential for smooth operations."
  },
  {
    "title": "Palghar to Mumbai Corporate Route",
    "description": "A crucial intercity route for corporate travel, client meetings, and executive transport between Palghar MIDC and Mumbai."
  }
],


"services": [
{
"name": "Corporate Cab Palghar MIDC",
"description": "eTravo offers reliable corporate cab services in Palghar MIDC designed for smooth industrial and business travel. Our service ensures punctual pickups, comfortable rides, and professional chauffeurs for daily office commuting and executive movement."
},
{
"name": "Taxi Service Palghar MIDC",
"description": "Our taxi services in Palghar MIDC provide quick and dependable transportation for professionals and workers. eTravo ensures clean vehicles, timely service, and a hassle-free travel experience across industrial zones."
},
{
"name": "Company Cab Palghar",
"description": "eTravo provides company cab services in Palghar tailored for corporate and industrial needs. From employee transport to executive travel, our service ensures reliability, safety, and smooth operations."
},
{
"name": "Office Transport Palghar MIDC",
"description": "Simplify employee commuting with eTravo’s office transport services in Palghar MIDC. We offer structured and efficient transportation solutions for daily travel across factories and offices."
},
{
"name": "Employee Cab Palghar",
"description": "Our employee cab services in Palghar are designed for safe and punctual commuting. eTravo ensures well-coordinated pickup and drop services for smooth daily travel."
},
{
"name": "Corporate Travel Palghar MIDC",
"description": "eTravo offers corporate travel services in Palghar MIDC for both local and outstation business needs. Our service ensures reliable and comfortable journeys for executives and employees."
},
{
"name": "Business Cab Palghar",
"description": "eTravo’s business cab services in Palghar are ideal for meetings, site visits, and corporate activities. Our service focuses on punctuality and professional travel experiences."
},
{
"name": "Staff Transport Palghar MIDC",
"description": "eTravo provides dependable staff transport services in Palghar MIDC for daily employee commuting. Our service ensures timely pickups, safe rides, and efficient coordination."
},
{
"name": "Corporate Taxi Palghar",
"description": "Our corporate taxi services in Palghar offer flexible and reliable transportation for businesses. eTravo ensures smooth travel for employees, executives, and corporate clients."
},
{
"name": "Company Taxi Palghar MIDC",
"description": "eTravo’s company taxi services in Palghar MIDC provide convenient travel solutions for corporate requirements. Our taxis are ideal for daily operations and client handling."
},
{
"name": "Corporate Pickup Drop Palghar",
"description": "eTravo offers corporate pickup and drop services in Palghar for efficient employee commuting. Our service ensures punctual scheduling and comfortable travel experiences."
},
{
"name": "Office Cab Booking Palghar",
"description": "Book office cabs in Palghar easily with eTravo. Our reliable service ensures timely pickups, comfortable rides, and hassle-free travel for corporate teams."
},
{
"name": "Business Travel Cab Palghar",
"description": "Our business travel cab services in Palghar are designed for professionals traveling for meetings and corporate tasks. eTravo ensures smooth and efficient journeys."
},
{
"name": "Corporate Commute Palghar MIDC",
"description": "eTravo’s corporate commute services in Palghar MIDC provide structured and dependable employee transportation. Our service ensures smooth daily travel for corporate staff."
},
{
"name": "Professional Cab Service Palghar",
"description": "eTravo offers professional cab services in Palghar with trained drivers and well-maintained vehicles. Our service ensures safe, comfortable, and reliable travel for all business needs."
}
],
"tableData": [
["Corporate Cab Palghar MIDC", "Taxi Service Palghar MIDC"],
["Company Cab Palghar", "Office Transport Palghar MIDC"],
["Employee Cab Palghar", "Corporate Travel Palghar MIDC"],
["Business Cab Palghar", "Staff Transport Palghar MIDC"],
["Corporate Taxi Palghar", "Company Taxi Palghar MIDC"],
["Corporate Pickup Drop Palghar", "Office Cab Booking Palghar"],
["Business Travel Cab Palghar", "Corporate Commute Palghar MIDC"],
["Professional Cab Service Palghar", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Service in Palghar MIDC",
      "WhyChoosedescription": "eTravo provides dependable corporate cab service in Palghar MIDC, ensuring smooth and efficient employee transportation for industries located in Tarapur, Boisar, and nearby industrial zones."
    },
    {
      "WhyChooseheading": "Perfect for Industrial Workforce Transport",
      "WhyChoosedescription": "Palghar MIDC is a major industrial hub with manufacturing units and factories, making structured employee transportation essential for daily operations and productivity."
    },
    {
      "WhyChooseheading": "Daily Employee Pickup and Drop Solutions",
      "WhyChoosedescription": "Our corporate cab services include fixed-route pickup and drop with optimized scheduling, ensuring employees reach their workplace on time without delays."
    },
    {
      "WhyChooseheading": "Wide Fleet for Workforce and Management Travel",
      "WhyChoosedescription": "We offer hatchbacks, sedans, SUVs, and larger employee transport vehicles suitable for both workforce commuting and management-level travel."
    },
    {
      "WhyChooseheading": "Experienced Drivers for MIDC Routes",
      "WhyChoosedescription": "Our chauffeurs are trained and familiar with Palghar MIDC, Tarapur, and Boisar routes, ensuring safe and efficient transportation for employees."
    },
    {
      "WhyChooseheading": "Flexible Monthly and Long-Term Contracts",
      "WhyChoosedescription": "eTravo offers cost-effective monthly and long-term corporate cab plans with dedicated vehicles and drivers for industrial clients."
    },
    {
      "WhyChooseheading": "Safe, Clean, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, ensuring safety, hygiene, and comfort for daily employee travel."
    },
    {
      "WhyChooseheading": "24/7 Support for Industrial Operations",
      "WhyChoosedescription": "Our support team operates round the clock to handle shift-based transport, schedule changes, and emergency travel requirements."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is corporate cab service in Palghar MIDC?',
            answer: 'Corporate cab service in Palghar MIDC provides organized transportation for employees working in industrial and manufacturing units including daily commute and shift-based travel.',
        },
        {
            question: 'Why is corporate transport important in Palghar MIDC?',
            answer: 'Reliable transportation ensures employees reach factories and offices on time, improving efficiency and reducing delays in industrial operations.',
        },
        {
            question: 'Do you provide daily pickup and drop for employees?',
            answer: 'Yes, eTravo offers structured daily pickup and drop services with fixed routes and timings.',
        },
        {
            question: 'Are monthly corporate cab contracts available?',
            answer: 'Yes, we provide monthly and long-term contracts with dedicated vehicles and drivers for companies.',
        },
        {
            question: 'What types of vehicles are available for MIDC transport?',
            answer: 'We offer hatchbacks, sedans, SUVs, and larger vehicles depending on workforce size and requirements.',
        },
        {
            question: 'Are drivers experienced in industrial routes?',
            answer: 'Yes, our drivers are trained and familiar with MIDC areas like Tarapur and Boisar.',
        },
        {
            question: 'Is the service available for shift-based operations?',
            answer: 'Yes, we provide transport solutions for day, night, and rotational shifts.',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, all vehicles are GPS-enabled with verified drivers and safety protocols.',
        },
        {
            question: 'Can corporate travel plans be customized?',
            answer: 'Yes, routes, schedules, and plans can be customized based on company requirements.',
        },
        {
            question: 'How can I book corporate cab service in Palghar MIDC?',
            answer: 'You can book through our website or contact our support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Patil',
        designation: 'Plant Head, Manufacturing Unit, Tarapur MIDC',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has improved our employee transport in Palghar MIDC. Their punctual service and professional drivers are perfect for industrial needs.”',
    },
    {
        name: 'Ms. Pooja Sharma',
        designation: 'HR Manager, Industrial Company, Palghar',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for workforce transportation. Their flexible plans and reliable service ensure smooth daily commuting for our employees.”',
    },
];






    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Palghar MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-palghar-midc.jpg",
  "description": "Reliable corporate cab services in Palghar MIDC by eTravo. Ideal for employee transport, office pickup and drop, business travel, and corporate commute with safe and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-service-in-palghar-midc"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cab Service in Palghar MIDC | Office & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab service in Palghar MIDC with eTravo for employee transport, office pickup and drop, business travel, and corporate commute solutions. Safe and reliable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/142.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporratecabdserviceinpalghar;